export default "__VITE_ASSET__CUCTtjBp__"